"use strict";

/* eslint-disable no-undef */
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _App = _interopRequireDefault(require("./App"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _backboneHubHttp = _interopRequireDefault(require("backbone-hub-http"));

var _usageTrackerContainer = require("usage-tracker-container");

var _UsageTracker = _interopRequireDefault(require("./utils/UsageTracker"));

var _RootModule = _interopRequireDefault(require("./RootModule"));

_backboneHubHttp.default.setClient(_apiClient.default);

(0, _usageTrackerContainer.setPrimaryTracker)(_UsageTracker.default); // add all images as assets

if (typeof require !== 'undefined') {
  require.context('bender-url!../images', true);
}

new _App.default((0, _RootModule.default)(), 'settings-ui-app').start();